import React from 'react';
import Icon from 'relements/build/esm/ui/icon';

export default ({ text = 'Error', addMode, onDelete, className, readOnly }) => {
  const addModeClassName = addMode ? 'add-mode' : '';
  return (
    <div
      className={`synonym-list-word ${addModeClassName} ${className}`}
      style={{ pointerEvents: readOnly ? 'none' : 'auto' }}
    >
      <span>{text}</span>
      {!readOnly ? <Icon src="trash" onClick={onDelete} /> : null}
    </div>
  );
};
